var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "currentColor",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 29.5C27.165 29.5 35 23.0081 35 15C35 6.99187 27.165 0.5 17.5 0.5C7.83502 0.5 0 6.99187 0 15C0 23.0081 7.83502 29.5 17.5 29.5ZM9 18.25C10.3807 18.25 11.5 17.1307 11.5 15.75C11.5 14.3693 10.3807 13.25 9 13.25C7.61929 13.25 6.5 14.3693 6.5 15.75C6.5 17.1307 7.61929 18.25 9 18.25ZM20 15.75C20 17.1307 18.8807 18.25 17.5 18.25C16.1193 18.25 15 17.1307 15 15.75C15 14.3693 16.1193 13.25 17.5 13.25C18.8807 13.25 20 14.3693 20 15.75ZM26 18.25C27.3807 18.25 28.5 17.1307 28.5 15.75C28.5 14.3693 27.3807 13.25 26 13.25C24.6193 13.25 23.5 14.3693 23.5 15.75C23.5 17.1307 24.6193 18.25 26 18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.1269ee797bd91da75a06f755e8f9e18b.svg";
export { ForwardRef as ReactComponent };